import {Card} from '@vio/atlas/Card'
import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/src/components/designSystem/SkeletonLoader'

const ROOM_CARD_GALLERY_WIDTH_V2 = 290
const ROOM_CARD_GALLERY_MAIN_HEIGHT_V2 = 195
const ROOM_CARD_GALLERY_SMALL_HEIGHT_V2 = 79

const RoomGallerySkeleton = () => (
  <Box display="flex" flexDirection="column" gap="s100">
    <Box
      width={`${ROOM_CARD_GALLERY_WIDTH_V2}px`}
      height={`${ROOM_CARD_GALLERY_MAIN_HEIGHT_V2}px`}
    >
      <SkeletonLoader height="100%" marginTop={0} />
    </Box>
    <Box display="flex" gap="s100">
      <Box width="144px" height={`${ROOM_CARD_GALLERY_SMALL_HEIGHT_V2}px`}>
        <SkeletonLoader height="100%" marginTop={0} />
      </Box>
      <Box width="144px" height={`${ROOM_CARD_GALLERY_SMALL_HEIGHT_V2}px`}>
        <SkeletonLoader height="100%" marginTop={0} />
      </Box>
    </Box>
  </Box>
)

const RoomBasicsSkeletonDesktop = () => (
  <Box display="flex" flexDirection="column" gap="s600">
    <Box display="flex" gap="s400" justifyContent="space-between">
      <SkeletonLoader width={200} marginTop={0} />
      <SkeletonLoader width={100} marginTop={0} />
    </Box>
    <div>
      <SkeletonLoader width={250} />
      <SkeletonLoader width={160} />
    </div>
  </Box>
)

export const RoomBasicsSkeletonMobile = () => (
  <Box display="flex" flexDirection="column" gap="s600">
    <SkeletonLoader width={200} marginTop={0} />
    <div>
      <SkeletonLoader width={250} />
      <SkeletonLoader width={160} />
    </div>
  </Box>
)

const DealInfoSkeleton = () => (
  <Box display="flex" flexDirection="column" gap="s600" flex="1">
    <div>
      <SkeletonLoader width={160} />
      <SkeletonLoader width={96} />
    </div>
    <div>
      <SkeletonLoader width={96} />
      <SkeletonLoader width={64} />
    </div>
  </Box>
)

const PriceAndActionsSkeleton = ({
  isRightAligned = false
}: {
  isRightAligned?: boolean
}) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems={isRightAligned ? 'flex-end' : 'flex-start'}
    gap="s600"
    maxWidth="220px"
    width="100%"
  >
    <div>
      <SkeletonLoader width={120} align={isRightAligned ? 'right' : 'left'} />
      <SkeletonLoader width={96} align={isRightAligned ? 'right' : 'left'} />
    </div>
    <SkeletonLoader style={{width: '100%'}} marginTop={0} />
  </Box>
)

const RoomOfferSkeleton = () => (
  <Box padding="s600">
    <Box display="flex" gap="s500" justifyContent="space-between">
      <DealInfoSkeleton />
      <PriceAndActionsSkeleton />
    </Box>
  </Box>
)

export const RoomCardSkeletonDesktop = () => (
  <Card borderColorPath="border.neutral.secondary" borderRadius="xl">
    <Box padding="s600">
      <Box display="flex" gap="s600">
        <RoomGallerySkeleton />
        <Box display="flex" flexDirection="column" flex="1" gap="s600">
          <RoomBasicsSkeletonDesktop />
          <Card borderColorPath="border.neutral.secondary" borderRadius="lg">
            <RoomOfferSkeleton />
          </Card>
        </Box>
      </Box>
    </Box>
  </Card>
)

export const RoomCardSkeletonDesktopXs = () => (
  <Card borderColorPath="border.neutral.secondary" borderRadius="xl">
    <Box display="flex" flexDirection="column" gap="s500">
      <Box height="298px">
        <SkeletonLoader height="100%" marginTop={0} />
      </Box>
      <Box paddingLeft="s500" paddingRight="s500" paddingBottom="s500">
        <RoomBasicsSkeletonMobile />
        <Box paddingTop="s500">
          <Card borderColorPath="border.neutral.secondary" borderRadius="lg">
            <RoomOfferSkeleton />
          </Card>
        </Box>
      </Box>
    </Box>
  </Card>
)

export const RoomOfferSkeletonVerticalMobile = () => (
  <Box padding="s500" display="flex" flexDirection="column" gap="s600">
    <DealInfoSkeleton />
    <Box display="flex" justifyContent="flex-end" width="100%">
      <PriceAndActionsSkeleton isRightAligned />
    </Box>
  </Box>
)
